import JsonApi from 'utils/jsonApi';
import type { NewLandingPageActionPayload } from 'commons/types';

export default class NewLandingPage {
  jsonApi: JsonApi;

  constructor(jsonApi: JsonApi) {
    this.jsonApi = jsonApi;
  }

  async getNewLandingPage(
    payload: NewLandingPageActionPayload,
    type: 'interest' | 'program',
  ): Promise<any> {
    try {
      const endpointName = type === 'interest' ? type : 'program_type';
      const degreeQuery = payload.query ? `?degree=${payload.query}` : '';
      const response = await this.jsonApi.get(
        `v2/${endpointName}s/${payload.slug.toLowerCase()}${degreeQuery}`,
        false,
      );
      return response.data;
    } catch (err) {
      throw new Error(err);
    }
  }
}
